import { createSlice } from "@reduxjs/toolkit";
import { realtorWebcardApi } from "../RealtorApi/RealtorApi";

const realtorWebcardApiSlice = createSlice({
  name: "realtor-webcard",
  initialState: {
    data: null, // Fix: Change from `[]` to `null`
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(realtorWebcardApi.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(realtorWebcardApi.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(realtorWebcardApi.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload; // Fix: Use `action.payload`
      });
  },
});

export default realtorWebcardApiSlice.reducer;
